// TODO: Add HS Implementation Guide Entry ID https://secondstep.atlassian.net/browse/LEARN-17544
export const ADMIN_DASHBOARD_ENTRY_ID = '5oqdbnI289AADFVmm2sJyx:en-US:5'
export const HS_IMPLEMENTATION_ENTRY_ID = 'qxnIojrDaH27CjKZzc6zC:en-US:5'
export const K8_IMPLEMENTATION_ENTRY_ID = '4ZErlVNUbLdWB4MJvEByfs:en-US:5'
